import { useMemo } from 'react';
import { useDi, API_BASE_URL } from '../../app/providers/DiProvider';
import { AdminApi } from './admin.api';

/** Resolves the AdminApi client from the DI container (base URL comes from env). */
export function useAdminApi(): AdminApi {
  const di = useDi();
  return useMemo(() => new AdminApi(di.resolve(API_BASE_URL)), [di]);
}
